import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2025M09() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-09-01.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Nina Schlechtriem
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    03 September 2025, Haus der Erde Association, Freiburg (Germany)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                     <i>Drawing Stories</i>: A Workshop on the Geometrical Art of the Huni Kuin Peoples of Amazonia
                  </Blockquote>
                  <Blockquote size="2" color>
                    Center Interstices in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    The Interstices Center, together with the Forest Guardian Institut (Brazil) and the Haus der Erde Association (Germany), organized a workshop with the <i>Huni Kuin</i>, an indigenous group of the Amazon Rainforest (Acre, Brazil). The focus of the workshop was the Huni Kuin's geometrical art, traditionally called <i>Kené</i>, which is implemented in handcrafts and used for body painting with a wide variety of motifs inspired by the geometric patterns found in the non-human beings of the Amazon Rainforest. 
                    The purpose of the workshop was to share this specific type of indigenous ancestral knowledge through art, stories, songs and prayers which may contribute to healing certain problematic aspects of our western ways of life. The event took place on 3 September 2025 at the Haus der Erde Association and was attended by an international audience (from Germany, Switzerland, France, Italy, and Brazil). 
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
